import { createIntl, createIntlCache } from 'react-intl';
import frMessages from './locales/fr.json';
import enMessages from './locales/en.json';
import esMessages from './locales/es.json';
import ptMessages from './locales/pt.json';
import nlMessages from './locales/nl.json';

export type SupportedLocale = 'fr' | 'en' | 'es' | 'pt' | 'nl';

// Function to flatten nested message objects
const flattenMessages = (nestedMessages: any, prefix = ''): Record<string, string> => {
  const messages: Record<string, string> = {};
  
  for (const key in nestedMessages) {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;
    
    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else if (typeof value === 'object' && value !== null) {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }
  }
  
  return messages;
};

export const messages = {
  fr: flattenMessages(frMessages),
  en: flattenMessages(enMessages),
  es: flattenMessages(esMessages),
  pt: flattenMessages(ptMessages),
  nl: flattenMessages(nlMessages),
};

// Create a cache for better performance
const cache = createIntlCache();

export const createIntlInstance = (locale: SupportedLocale) => {
  return createIntl(
    {
      locale,
      messages: messages[locale],
    },
    cache
  );
};

export const defaultLocale: SupportedLocale = 'fr';
